import {
  SET_HIDDEN,
  FETCHED_SUB_DEMAND_OFFERS
} from '../types';
import {lowestDenom,pairs} from '../../config';
import {Decimal} from 'decimal.js';

export function collateralizeFilterDispatch() {
  return (dispatch,getState) => collateralizeFilter(dispatch,getState())
}

export function collateralizeFilter(dispatch,state){
  try {
    let {denomination,asset,type} = state.ui_marketplace.market;
    let {bids,asks} = state.orderbook.pairs[state.ui_marketplace.market.type][`${asset}/${denomination}`]

    let filterOffers = combine(asks,denomination.toLowerCase(),state.socket.bcHeight,false);
    let filterDemand = combine(bids,denomination.toLowerCase(),state.socket.bcHeight,true);

    let max = denomination.toUpperCase() == 'NRG' ? 35 : 17;

    for(let i = filterDemand.length; i < max; i++) {
      filterDemand.push({isBlank:true})
    }

    for(let i = filterOffers.length; i < max; i++) {
      filterOffers.unshift({isBlank:true})
    }

    dispatch({
      type: FETCHED_SUB_DEMAND_OFFERS,
      payload:{offers:filterOffers,demand:filterDemand}
    });
  }
  catch(err){
    console.log({err})
  }
}

let combine = (arr,denomination,block,bid) => {
  let hash = {};
  arr.filter(a => {return a.tradeHeight + a.deposit - 3 > block}).forEach((a)=>{
    if(hash[a.price]){
      hash[a.price].orders.push(a)
      hash[a.price].amount = hash[a.price].amount.add(new Decimal(a.amount))
    }
    else {
      hash[a.price] = {amount:new Decimal(a.amount),orders:[a]}
    }
  });

  let orders = [];
  Object.keys(hash).forEach((price)=>{
    orders.push({price:new Decimal(price),amount:hash[price].amount,orders:hash[price].orders});
  });

  if(bid) orders.sort((a, b) => b.price - a.price)
  else orders.sort((a, b) => a.price - b.price)

  if(orders.length > 0){
    orders[0].cml = cml(orders[0]);
    orders[0].amountCml = orders[0].amount.toString();

    for(let i = 1; i < orders.length;i++){
      let prev = orders[i-1];
      let o = orders[i];
      o.cml = new Decimal(prev.cml).add(cml(o)).toString()
      o.amountCml = new Decimal(prev.amountCml).add(o.amount).toString()
    }
  }

  if(!bid) orders.sort((a, b) => b.price - a.price)

  return orders;
}

let cml = (order) => {return order.price.mul(order.amount).toString()}
